import React from 'react';
import { getProgress, getPointsToNext } from '../utils/buildingLevels';

/**
 * Progress Bar Component
 * Shows progress to next level with visual bar
 */
const ProgressBar = ({ points, level }) => {
  if (!level) return null;

  const progress = getProgress(points);
  const pointsToNext = getPointsToNext(points);
  const isMaxLevel = level.max === Infinity;

  return (
    <div className="w-full space-y-1">
      {/* Progress bar */}
      <div className="w-full bg-gray-200 rounded-full h-2.5 overflow-hidden">
        <div
          className={`h-full ${level.bgColor} transition-all duration-500 ease-out rounded-full`}
          style={{ width: `${progress}%` }}
        />
      </div>

      {/* Progress text */}
      <div className="flex justify-between items-center text-xs text-gray-600">
        {isMaxLevel ? (
          <span className="font-semibold text-purple-600">Μέγιστο Επίπεδο! 🎉</span>
        ) : (
          <>
            <span>
              {points - level.min} / {level.max - level.min} πόντοι
            </span>
            <span className="font-semibold">
              Υπολείπονται {pointsToNext} για {level.next}
            </span>
          </>
        )}
      </div>
    </div>
  );
};

export default ProgressBar;
